import { Paper, Stack, Typography, styled } from '@mui/material'
import PopoverJoinNowCC from 'components/Popover/PopoverJoinNowCC'
import PopoverMeetingCC from 'components/Popover/PopoverMeetingCC'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { checkFunctionHaveCode } from 'store/user/functions'
import { selectCurrentUserFunctions } from 'store/selectors'
import { color } from 'theme'
import useMenuPage from './hooks/useMenuPage'
import { PATH_ROOT } from 'constants/api'
const MEET = 'meet'

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    width: '45%',
    display: 'flex',
    flexDirection: 'column'
}));

const MenuPage = () => {
    const { t } = useTranslation()
    const { listMenu, handleNavigate } = useMenuPage()
    const functions = useSelector(selectCurrentUserFunctions)
    
    return (
        <Stack gap={1} px={3} py={1}>
            <Typography sx={{ color: color.default, fontWeight: 700, fontSize: 16 }}>{t('menu-mobile.yourShotcut')}</Typography>
            <Stack direction={'row'} justifyContent={'space-around'}>
                <PopoverMeetingCC type={MEET} alawaysShow={true}/>
                <PopoverJoinNowCC alawaysShow={true}/>
            </Stack>
            <Typography sx={{ color: color.default, fontWeight: 700, fontSize: 16 }}>{t('menu-mobile.allShotcuts')}</Typography>
            <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" px={3} justifyContent={'space-around'}>
                {/* Kiểm tra theo grouprole */}
                {/* {listMenu.filter(menu => stateCurrent?.roles.includes(MANAGER_CONFIG_SYSTEM) ? menu : menu.role === ROLE_LIST_MENU.GUEST && menu).map((menu, index) => (
                    <Item key={index} onClick={() => handleNavigate(menu.path)}>
                        {menu.icon}
                        {t(menu.name)}
                    </Item>
                ))} */}
                {/* Kiểm tra theo license/role */}
                {listMenu.filter(menu => checkFunctionHaveCode(functions, menu.rolev2) ? menu : menu.rolev2 === 'NO_NEED' && menu).map((menu, index) => (
                    <Item key={index} onClick={() => handleNavigate(`${PATH_ROOT}${menu.path}`)}>
                        {menu.icon}
                        {t(menu.name)}
                    </Item>
                ))}
            </Stack>
        </Stack>
    )
}

export default MenuPage
